<template>
  <div id="gift-card-popup" class="pos-fixed" @click.stop.prevent>
    <div class="overlay" @click.stop.prevent="toggleGiftModal(false, giftContent)"></div>
    <div class="bg-light card-details padding-10 pos-fixed pos-center-ver pos-center-hor index-3 radius-3" style="margin: auto 5px;">
      <div class="card-name margin-bottom-20 font-bold">{{giftContent.name}}</div>
      <div class="fill-in-details" v-if="isGCBuy">
        <div class="text-left margin-bottom-20">
          <div class="receiver-name margin-bottom-10">
            <div class="text-small">Receiver's Name*</div>
            <input class="margin-bottom-10 custom-input full-width" type="text" v-model="receiverName" placeholder="Enter Receiver's Name*">
          </div>
          <div class="receiver-email margin-bottom-10" v-if="showContactNumber(giftContent.name)">
            <div class="text-small">Receiver's Contact Number*</div>
            <input class="margin-bottom-10 custom-input full-width" type="number" v-model="receiverEmail" placeholder="Enter Receiver's Contact Number*">
          </div>
          <div class="receiver-email margin-bottom-10" v-else>
            <div class="text-small">Receiver's Email*</div>
            <input class="margin-bottom-10 custom-input full-width" type="text" v-model="receiverEmail" placeholder="Enter Receiver's Email*">
          </div>
          <div class="value-bal align-hor center-ver">
            <div class="w50 align-ver center-hor">
              <div>Value:</div>
              <div class="font-bold">₹{{giftContent.value}}</div>
            </div>
            <div class="w50 align-ver center-hor">
              <div>Required Balance:</div>
              <div class="font-bold">{{formatReward(giftContent.currency_label, giftContent.currency_req, true)}}</div>
            </div>
          </div>
        </div>
        <button class="custom-button small text-light padding-0510 radius-5 text-uppercase" :style="{background: bgTheme}" @click.stop.prevent="buyGiftCard(giftContent)">buy</button>
      </div>
      <div class="redeemed-details text-semi-small" v-else>
        <img class="w30 margin-bottom-5" :src="giftContent.image_url">
        <table class="text-left">
          <tbody>
            <tr>
              <td>Date:</td>
              <td class="font-bold">{{new Date().getDate()}}/{{new Date().getMonth()}}/{{new Date().getFullYear()}}</td>
            </tr>
            <tr>
              <td>Ref Number:</td>
              <td class="font-bold">{{refNum}}</td>
            </tr>
            <tr>
              <td>Name:</td>
              <td class="font-bold">{{receiverName}}</td>
            </tr>
            <tr>
              <td v-if="showContactNumber(giftContent.name)">Contact Number:</td>
              <td v-else>Email:</td>
              <td class="font-bold">{{receiverEmail}}</td>
            </tr>
            <tr>
              <td>Gift Card Value:</td>
              <td class="font-bold">₹{{giftContent.value}}</td>
            </tr>
            <tr>
              <td>Balance Used:</td>
              <td class="align-hor center-ver font-bold">
                <img class="w-15 margin-right-5" :src="userHeaderBalance.icon">
                <div>{{formatReward(giftContent.currency_label, giftContent.currency_req, true)}}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  export default {
    mixins: [globals],
    props: {
      model: Object
    },
    data() {
      return {
        receiverName: '',
        receiverEmail: '',
        refNum: ''
      }
    },
    methods: {
      showContactNumber(name){
        return name.toLowerCase().includes('paytm')
      },
      buyGiftCard(gc) {
        var name = this.receiverName;
        var email = this.receiverEmail;
        var sku = gc.sku;
        var price = gc.value;
        if(!name) {
          this.toastPopup(true, "Please enter the receiver name");
          return false;
        }

        if(!email) {
          this.toastPopup(true, "Please enter the receiver email");
          return false;
        }

        if(!sku) {
          this.toastPopup(true, "Invalid Gift card!");
          return false;
        }

        if(!price) {
          this.toastPopup(true, "Invalid amount!");
          return false;
        }

        var data = {
          name: name,
          email: email,
          sku: sku,
          price: price
        }

        var url = this.$store.getters.flyyDomain+'/buy_gift_cards';
        var headers = this.$store.getters.headers;

        var options = {
          method: 'post',
          url: url,
          headers: headers,
          data: data,
        }

        axios(options).then((resp) => {
          if(resp.status == 200) {
            if(resp.data.success) {
              this.$store.state.giftCardBuy = false;
              this.refNum = resp.data.ref_num;
              this.toastPopup(true, resp.data.message);
            } else {
              this.toggleGiftModal(false, gc)
              this.toastPopup(true, resp.data.message);
            }
          } else {
            this.toggleGiftModal(false, gc)
            this.toastPopup(true, resp.data.message);
          }
        }).catch((err) => {
          this.toggleGiftModal(false, gc)
          console.log("Redemption error!");
        });
      }
    },
    created() {
      var trans = this.model
      if(!this.isEmpty(trans) && !this.isEmpty(trans.gift_card)) {
        var gc = trans.gift_card
        var tempObj = {}
        tempObj.name = gc.pr_name;
        tempObj.value = gc.amount;
        tempObj.currency_req = trans.value;
        tempObj.currency_label = trans.prize_type;
        tempObj.image_url = gc.pr_image;
        this.receiverName = gc.name;
        this.receiverEmail = gc.email;
        this.refNum = gc.ref_num;
        this.$store.state.gift_content = tempObj;
        this.$store.state.giftCardBuy = false;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/gift-card-popup.vue